import Vue from "vue";
import Vuex from "vuex";
import api from "../utils/api";
import reportStore from "./modules/report";
import subscribeStore from "./modules/subscribe";
import orderStore from "./modules/order";
import coldStore from "./modules/cold";
import sciStore from "./modules/sci";
import gomStore from "./modules/gom";
import userStore from "./modules/user";
import createPersistedState from "vuex-persistedstate";
import approveStore from "./modules/report/approve";
import ownerHousePropertyStore from "./modules/report/owner-house-property";
import irosStore from "./modules/iros";
import issueStore from "./modules/report/issue";
import dobyStore from "./modules/doby";
import buyStore from "./modules/report/buy";
import userLoginStore from "./modules/user/login";
import insuranceStore from "./modules/insurance";
import firstamStore from "./modules/firstam";
import couponStore from "./modules/coupon";
import creditStore from "./modules/credit";
import typhoonStore from "./modules/typhoon";
import sherlockPointStore from "./modules/sherlock-point";
import alfredStore from "./modules/alfred";
import subscribePremiumStore from "./modules/subscribe-premium";
import premiumEngineStore from "./modules/premium-engine";
import cowSuspectStore from "./modules/cow-suspect";
import directDealStore from "./modules/direct-deal";
import refundStore from "./modules/refund";
import registryBatchStore from "./modules/registry-batch";
import manualPaymentStore from "./modules/manual-payment";
import beaverStore from "./modules/beaver";
import reportIssueTimeStore from "./modules/report-issue-time";
import externalApiMaintenanceStore from "./modules/external-api-maintenance";
import reportQnaStore from "./modules/report-qna";
import reportValuationStore from "./modules/report-valuation";
import promptAdminStore from "./modules/prompt-admin";
import { fetchWithdrawalDetail, fetchWithdrawalList } from "../utils/withdrawal";
const qs = require("qs");

Vue.use(Vuex);
const host = process.env.VUE_APP_HOST;

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      paths: [
        "reportStore",
        "subscribeStore",
        "orderStore",
        "coldStore",
        "gomStore",
        "dobyStore",
        "creditStore",
        "userLoginStore",
        "insuranceStore",
        "couponStore",
        "typhoonStore",
        "sherlockPointStore",
        "subscribePremiumStore",
      ],
    }),
  ],
  state: {
    _page: {
      order: [],
    },
    _count: {
      itemCount: 0,
    },
    _state: {
      loadingBool: false,
      toastBool: false,
    },
    _type: {
      form: [],
      msg: "",
      detailIdx: 0,
      event: "",
      profile: null,
    },
    _modal: {
      modalState: false,
      alertState: false,
      alertTitleState: false,
      confirmState: false,
      msg: "",
      title: "",
      event: "",
      toastMsg: "",
      analyzeModal: false,
    },
    _variable: {
      userNo: "",
    },
    _items: {
      order: [],
      detail: [],
      report: [],
      user: [],
      withdrawals: [],
      withdrawalDetail: null,
      withdrawalAttempts: [],
      withdrawalAlerts: [],
      withdrawalEvents: [],
      withdrawalTotal: 0,
      act_score: 0,
    },
  },
  getters: {},
  mutations: {
    setLoadingState(state, type) {
      state._state.loadingBool = type;
    },
    setToastState(state, { status, message }) {
      state._state.toastBool = status;
      state._modal.toastMsg = message;
    },
    setOrderConfirmList(state, item) {
      // window.console.log("state item", item);
      try {
        let userItem = [];
        let reportItem = [];
        let dateTime;
        let dateHour;
        const items = item.orders
          .map(ele => {
            const orderReportCart = ele.orderReportCartEager[0];
            // window.console.log("asfasfasfas", item.users);
            userItem = item.users.find(index => index.userNo.includes(ele.userNo));
            reportItem = item.reports.find(index => index.cartSeq.includes(orderReportCart?.cartSeq));
            dateTime = new Date(ele.createDate.replace("T", " ").replace(".000Z", ""));
            dateHour = new Date(ele.createDate.replace("T", " ").replace(".000Z", "")).getHours() + 9;

            const lastUpdateDateTime = new Date(orderReportCart?.modifyDate?.replace("T", " ").replace(".000Z", ""));
            const lastUpdateDateHour =
              new Date(orderReportCart?.modifyDate?.replace("T", " ").replace(".000Z", "")).getHours() + 9;

            // window.console.log("reportItemreportItem", reportItem);
            // window.console.log("userItem", userItem);
            if (userItem) {
              return {
                order_seq: ele.orderSeq,
                order_type: ele.orderType,
                order_type_name:
                  ele.orderType === "1"
                    ? "프리미엄 리포트"
                    : ele.orderType === "3"
                    ? "우리 집 알리미"
                    : "전세대출 리포트",
                user_no: ele.userNo,
                status: ele.status,
                address: orderReportCart?.address,
                cart_seq: orderReportCart?.cartSeq,
                report_yn: orderReportCart?.reportYn,
                pass_yn: ele.passYn,
                approve_yn: ele.approveYn,
                confirm_yn: reportItem?.reportYn ? true : false,
                // NZSC-3250: 질문 건 1차 통과 표식 — 목록에서 "승인 완료" 표시 근거(작업자1 루틴 불변)
                qna_first_pass_yn: reportItem?.qnaFirstPassYn ?? 0,
                qna_review_status: reportItem?.qnaReviewStatus ?? null,
                cold_yn: orderReportCart?.coldYn,
                // NZSC-4036: 자체발급(비버) 큐 상태 — '작업 전' 대신 '줄 서는 중(앞에 N팀)' 표시용
                self_issue: item.selfIssue ? item.selfIssue[ele.orderSeq] || null : null,
                confirm: orderReportCart?.confirm,
                user_name: userItem.userName ? userItem.userName : userItem.userNick,
                mobile: userItem.mobile,
                // NZSC-3205: 다방 등 파트너 채널 배지 표시용 (DABANG이면 email/mobile null)
                platform_type: userItem.platformType,
                // NZSC-3205: 이름/이메일 없는 채널 회원 식별용 리포트코드
                // 정본 = cart(조기채번). report.reportCode 는 승계 미구현으로 전원 NULL(2026-07-28 실측).
                report_code: orderReportCart?.reportCode ?? reportItem?.reportCode ?? null,
                contract_period: orderReportCart?.contractPeriod,
                manager_name: ele.orderReportCartAssignManager[0]?.name,
                address_status: orderReportCart?.addressStatus,
                building_dong: orderReportCart?.buildingDong,
                create_date: new Date(dateTime?.setHours(dateHour)).toLocaleString(),
                last_update_date: new Date(lastUpdateDateTime?.setHours(lastUpdateDateHour)).toLocaleString(),
                address_status: orderReportCart?.addressStatus,
              };
            }
          })
          .filter(data => data);
        state._items.order = [];
        window.console.log("items확인 확인", items);
        state._items.order = items;
        state._page.order = [];
        state._page.order = item.page;
      } catch (e) {
        console.log("eeee", e);
      }

      console.log("오예예예예", state._items.order);
    },
    setOrderConfirmDetail(state, item) {
      item.createDate = item.createDate.replace("T", " ").replace(".000Z", "");
      item.addressBase = `${item.addressJibun ? item.addressJibun : ""} ${item.buildingName ? item.buildingName : ""} ${
        item.buildingDong ? item.buildingDong : ""
      } ${item.buildingHo ? item.buildingHo : ""}`;
      state._items.detail = [];
      state._items.detail = Object.assign([], item);
    },
    setUserDetail(state, user) {
      state._items.user = user;
    },
    setUserNo(state, user_no) {
      state._variable.userNo = user_no;
    },
    setOrderSaveDetail(state, item) {
      console.log("go", item);
      const list = item;
      list[0]?.collateralData?.info.forEach(e => {
        (e.amount = e.amount.toLocaleString()), (e.name = e.name?.replace("근저당권자", "").replace("근저당권", ""));
      });
      state._items.report = [];
      state._items.report = list;
    },
    setFirstDeposit(state, item) {
      console.log("go", item);
      state._items.report.firstDeposit = item.firstDeposit;
    },
    setReportPre(state, item) {
      state._items.report = [];
      state._items.report = Object.assign([], item);
    },
    setAnalyzeModal(state, item) {
      state._modal.analyzeModal = item;
    },
    setReset(state) {
      state._items.order = [];
      state._items.detail = [];
      state._items.report = [];
    },
    setActScore(state, item) {
      state._items.act_score = item;
    },
    acWithdrawalList(state, item) {
      const payload = item || {};
      state._items.withdrawals = Array.isArray(payload.items) ? payload.items : [];
      state._items.withdrawalTotal = Number(payload.total || 0);
    },
    setWithdrawalDetail(state, item) {
      state._items.withdrawalDetail = item || null;
    },
    setWithdrawalAttempts(state, item) {
      state._items.withdrawalAttempts = Array.isArray(item?.items) ? item.items : [];
    },
    setWithdrawalAlerts(state, item) {
      state._items.withdrawalAlerts = Array.isArray(item?.items) ? item.items : [];
    },
    setWithdrawalEvents(state, item) {
      state._items.withdrawalEvents = Array.isArray(item?.items) ? item.items : [];
    },
  },
  actions: {
    async acWithdrawalList({ commit }, params = {}) {
      try {
        const payload = await fetchWithdrawalList(api, params);
        commit("acWithdrawalList", payload);
        return payload;
      } catch (err) {
        console.log(err);
        commit("acWithdrawalList", { items: [], total: 0 });
        throw err;
      }
    },
    async acWithdrawalDetail({ commit }, recordKey) {
      try {
        const { detail, attempts, alerts, events } = await fetchWithdrawalDetail(api, recordKey);
        commit("setWithdrawalDetail", detail);
        commit("setWithdrawalAttempts", { items: attempts });
        commit("setWithdrawalAlerts", { items: alerts });
        commit("setWithdrawalEvents", { items: events });
        return detail;
      } catch (err) {
        console.log(err);
        commit("setWithdrawalDetail", null);
        commit("setWithdrawalAttempts", { items: [] });
        commit("setWithdrawalAlerts", { items: [] });
        commit("setWithdrawalEvents", { items: [] });
        return null;
      }
    },

    async acLoginState({ state }) {
      try {
        const url = `/api/v1/user/admin/auth/token`;
        const res = await api.get(url);
        state._state.loadingBool = false;
        return res;
      } catch (error) {
        state._state.loadingBool = false;
        // 기기 증명 거절은 로그인 만료가 아니다 — 지우면 로그인·기기 연결 정보까지 날아간다(KRE-17 차단 테스트).
        //   로그인은 유지하고 기기 화면으로 보낸다(차단이 켜져 있고 이 브라우저가 등록·연결 전인 경우).
        if (error?.status === 403 && error?.data?.message === "device_proof_denied") {
          if (window.location.pathname !== "/admin-devices") window.location.assign("/admin-devices");
          return { deviceRequired: true };
        }
        console.warn("acLoginState failed");
        return null;
      }
    },
    async acReportFileUpdate({ commit }, forms) {
      const url = `${host}/api/v1/report-file/admin/update`;

      console.log("forms", forms);
      try {
        const res = await api.patch(url, forms);
        return res;
      } catch (err) {
        console.log("err", err.message);
        return null;
      } finally {
        console.log(commit);
      }
    },
    async acOrderConfirmList({ state, commit }, params) {
      try {
        const url = `/api/v1/orders`;
        const res = await api.get(url, {
          params: params,
        });
        const userNo = [];
        res.data.data.items?.forEach(element => {
          userNo.push(element.userNo);
        });

        const user_url = `/api/v1/user/admin/order-user`;
        const users = await api.get(user_url, {
          params: {
            members: userNo,
          },
          paramSerializer: params => {
            return qs.stringify(params, { arrayFormat: "repeat" });
          },
        });

        const cartNo = [];
        res.data.data.items?.forEach(element => {
          cartNo.push(element.orderReportCartEager[0].cartSeq);
        });

        const report_url = `/api/v1/report/report-user`;
        const reports = await api.get(report_url, {
          params: {
            carts: cartNo,
          },
          paramSerializer: params => {
            return qs.stringify(params, { arrayFormat: "repeat" });
          },
        });

        const page = {
          pageSize: res.data.data.pageSize,
          totalCount: res.data.data.totalCount,
          totalPage: res.data.data.totalPage,
        };
        // NZSC-4036: 자체발급 큐 상태(주문별) — 실패해도 목록은 기존대로
        let selfIssue = {};
        try {
          const orderNos = (res.data.data.items || []).map(e => e.orderSeq).filter(Boolean);
          if (orderNos.length) {
            const si = await api.get(`/api/v1/report/self-issue-status`, {
              params: { orders: orderNos },
              paramSerializer: params => qs.stringify(params, { arrayFormat: "repeat" }),
            });
            (si.data.data || []).forEach(x => {
              selfIssue[x.orderSeq] = x;
            });
          }
        } catch (e) {
          selfIssue = {};
        }
        commit("setOrderConfirmList", {
          page: page,
          orders: res.data.data.items,
          users: users.data.data,
          reports: reports.data.data,
          selfIssue,
        });
        return res.data;
      } catch (error) {
        state._state.loadingBool = false;
        console.log("acReportList error response", error.response);
        console.log("acReportList error request", error.request);
        console.log("acReportList error message", error.message);
        return null;
      } finally {
        commit("setLoadingState", false);
      }
    },
    async acOrderUndeterminedList({ state, commit }, params) {
      try {
        const url = `/api/v1/orders/undetermined`;
        const res = await api.get(url, {
          params: params,
        });
        const userNo = [];
        // window.console.log(`undetermined res`, res);
        res.data.data.items?.forEach(element => {
          userNo.push(element.userNo);
        });

        const user_url = `/api/v1/user/admin/order-user`;
        const users = await api.get(user_url, {
          params: {
            members: userNo,
          },
          paramSerializer: params => {
            return qs.stringify(params, { arrayFormat: "repeat" });
          },
        });

        const cartNo = [];
        res.data.data.items?.forEach(element => {
          cartNo.push(element.orderReportCartEager[0].cartSeq);
        });

        const report_url = `/api/v1/report/report-user`;
        const reports = await api.get(report_url, {
          params: {
            carts: cartNo,
          },
          paramSerializer: params => {
            return qs.stringify(params, { arrayFormat: "repeat" });
          },
        });

        const page = {
          pageSize: res.data.data.pageSize,
          totalCount: res.data.data.totalCount,
          totalPage: res.data.data.totalPage,
        };
        // NZSC-4036: 자체발급 큐 상태(주문별) — 실패해도 목록은 기존대로
        let selfIssue = {};
        try {
          const orderNos = (res.data.data.items || []).map(e => e.orderSeq).filter(Boolean);
          if (orderNos.length) {
            const si = await api.get(`/api/v1/report/self-issue-status`, {
              params: { orders: orderNos },
              paramSerializer: params => qs.stringify(params, { arrayFormat: "repeat" }),
            });
            (si.data.data || []).forEach(x => {
              selfIssue[x.orderSeq] = x;
            });
          }
        } catch (e) {
          selfIssue = {};
        }
        commit("setOrderConfirmList", {
          page: page,
          orders: res.data.data.items,
          users: users.data.data,
          reports: reports.data.data,
          selfIssue,
        });
        return res.data;
      } catch (error) {
        state._state.loadingBool = false;
        console.log("acOrderUndeterminedList error response", error.response);
        console.log("acOrderUndeterminedList error request", error.request);
        console.log("acOrderUndeterminedList error message", error.message);
        return null;
      } finally {
        commit("setLoadingState", false);
      }
    },
    async acOrderConfirmDetail({ commit }, order_seq) {
      try {
        const url = `/api/v1/order/${order_seq}`;
        const res = await api.get(url);

        console.log("acOrderConfirmDetail", res);
        commit("setOrderConfirmDetail", res.data.data);
        return res;
      } catch (error) {
        console.log("acCallGet error response", error.response);
        console.log("acCallGet error request", error.request);
        console.log("acCallGet error message", error.message);
        return error;
      } finally {
        commit("setLoadingState", false);
      }
    },
    async acUserDetail({ commit }, request) {
      try {
        const url = `/api/v1/user/admin`;
        const res = await api.get(url, {
          params: {
            member_no: request,
          },
        });

        commit("setUserDetail", res.data.data);
        return res;
      } catch (error) {
        state._state.loadingBool = false;
        console.log("acCallGet error response", error.response);
        console.log("acCallGet error request", error.request);
        console.log("acCallGet error message", error.message);
        return error;
      } finally {
        commit("setLoadingState", false);
      }
    },
    async acOrderStatus({ commit }, body) {
      const url = `/api/v1/order/report-cart`;
      try {
        const res = await api.post(url, body);
        return res;
      } catch (err) {
        console.log("err", err.message);
        return null;
      } finally {
        commit("setLoadingState", false);
      }
    },
    async acOrderSaveDetail({ commit }, cart_seq) {
      try {
        const url = `/api/v1/report/admin/order-cart/${cart_seq}`;
        const res = await api.get(url);

        console.log("acOrderSaveDetail", res);
        commit("setOrderSaveDetail", res.data.data);

        return res;
      } catch (error) {
        console.log("acCallGet error response", error.response);
        console.log("acCallGet error request", error.request);
        console.log("acCallGet error message", error.message);
        return error;
      } finally {
        commit("setLoadingState", false);
      }
    },
    async acUpdateFirstDeposit({ commit }, cart_seq) {
      try {
        const url = `/api/v1/report/admin/order-cart/${cart_seq}`;
        const res = await api.get(url);

        console.log("acUpdateFirstDeposit", res);
        commit("setFirstDeposit", res.data.data);

        return res;
      } catch (error) {
        console.log("acCallGet error response", error.response);
        console.log("acCallGet error request", error.request);
        console.log("acCallGet error message", error.message);
        return error;
      } finally {
        commit("setLoadingState", false);
      }
    },
    async acOrderReportCartMemoSave({ commit }, params) {
      try {
        const url = `/api/v1/order/cs/memo`;
        const res = await api.post(url, params);

        console.log("commit", commit);
        console.log("res acOrderReportCartSave", res);

        if (!res.data.message === "success") {
          return false;
        }
        return true;
      } catch (error) {
        console.log("error아아아아", error);
        return false;
      }
    },

    async acReportPre({ commit }, report_seq) {
      try {
        const url = `/api/v1/report/admin/${report_seq}`;
        const res = await api.get(url);

        console.log("acReportPre", res);
        commit("setReportPre", res.data.data);
        return res;
      } catch (error) {
        return error;
      } finally {
        commit("setLoadingState", false);
      }
    },
    async acReportConfirm({ commit }, body) {
      const url = `/api/v1/report/confirm/${body.seq}`;
      try {
        const res = await api.patch(url, {
          order_seq: body.order,
          is_status: body.is_status,
        });
        // NZSC-3250: 'FIRST_PASS_ONLY'(질문 건 1차승인만) | 'APPROVED'(즉시 승인)
        return res.data?.data || true;
      } catch (err) {
        console.log("err", err.message);
        return null;
      } finally {
        commit("setLoadingState", false);
      }
    },
    async acAnalyze({ commit }, item) {
      const url = `/api/v1/user/admin/report-alarm`;
      try {
        const res = await api.post(url, {
          member_no: item.user_no,
          report_type: item.report_type,
        });
        return res.data;
      } catch (err) {
        console.log("err", err.message);
        return null;
      } finally {
        commit("setLoadingState", false);
      }
    },
    // NZSC-4036: 주문 1건의 자체발급 큐 상태. 큐에 있으면 수동분석은 콜드가 조용히 무시하므로 사전 안내용.
    async acSelfIssueStatus(_ctx, order_seq) {
      try {
        const res = await api.get(`/api/v1/report/self-issue-status`, {
          params: { orders: [order_seq] },
          paramSerializer: params => qs.stringify(params, { arrayFormat: "repeat" }),
        });
        return (res.data.data || [])[0] || null;
      } catch (e) {
        return null;
      }
    },
    async acEstateCode({ commit }, { address, page }) {
      try {
        const url = `/api/v1/estate/unique-nos?address=${address}&page=${page}`;
        const res = await api.get(url);
        return res.data.data;
      } catch (error) {
        return null;
      } finally {
        commit("setLoadingState", false);
      }
    },
    async acEstatePdf({}, uniqueNo) {
      try {
        const url = `/api/v1/estate/iros-pdf?unique_no=${uniqueNo}`;
        const res = await api.get(url);
        return res.data.data;
      } catch (error) {
        return null;
      }
    },
    acloadingState({ commit }, type) {
      commit("setLoadingState", type);
    },
    acToastState({ commit }, { status, message }) {
      commit("setToastState", { status, message });
    },
    acUserNo({ commit }, user_no) {
      commit("setUserNo", user_no);
    },
    acAnalyzeModal({ commit }, value) {
      commit("setAnalyzeModal", value);
    },
    acReset({ commit }, value) {
      commit("setReset", value);
    },
    acActScore({ commit }, item) {
      commit("setActScore", item);
    },
  },
  modules: {
    reportStore,
    subscribeStore,
    orderStore,
    coldStore,
    sciStore,
    gomStore,
    userStore,
    approveStore,
    ownerHousePropertyStore,
    irosStore,
    issueStore,
    dobyStore,
    buyStore,
    userLoginStore,
    dobyStore,
    insuranceStore,
    firstamStore,
    couponStore,
    creditStore,
    typhoonStore,
    sherlockPointStore,
    alfredStore,
    subscribePremiumStore,
    premiumEngineStore,
    cowSuspectStore,
    directDealStore,
    refundStore,
    registryBatchStore,
    manualPaymentStore,
    beaverStore,
    reportIssueTimeStore,
    externalApiMaintenanceStore,
    reportQnaStore,
    reportValuationStore,
    promptAdminStore,
  },
});
